import { PerDiem } from "@finway-group/shared/lib/models"
import { Button, Col, Form, Row } from "antd"
import { useExpenseFormContext } from "Components/modals/expenseCreateForm.context"
import React from "react"
import { PlusCircle } from "react-feather"
import { useTranslation } from "react-i18next"
import { PerDiemDestinationField } from "./components/perDiemDestinationField"
import { FormPerDiemDestinationItinerary } from "./perDiem.form"

export const PerDiemDestinationFormFieldsContainer: React.FC = () => {
    const { t } = useTranslation()
    const [{ updateExpense, expenseForm, expense }] = useExpenseFormContext()

    const currentDestinationsState: FormPerDiemDestinationItinerary[] = expenseForm.getFieldValue(["destinations"]) ?? []

    const adjustDestinationsOnChange = () => {
        adjustStartDateOfDestinations()
        syncDestinationState()
    }
    // function to update expense to follow the form
    const syncDestinationState = () => {
        const newDestinations = [...expenseForm.getFieldValue(["destinations"])]
        const updateData: any = { destinations: newDestinations }
        const lastDestination = newDestinations[newDestinations.length - 1]
        // Only update datePurchased if the last destination is valid
        if (lastDestination) updateData.datePurchased = lastDestination.endDate
        updateExpense({ ...updateData })
    }

    /**
     * End date of destination [0] will be the start date of destination [1]
     * So changes in a destination's endDate will change the next startDate
     */
    const adjustStartDateOfDestinations = () => {
        const destinations: FormPerDiemDestinationItinerary[] = expenseForm.getFieldValue(["destinations"])
        if (destinations?.length > 1) {
            for (let i = 1; i < destinations.length; i++) {
                destinations[i].startDate = destinations[i - 1].endDate
            }
            expenseForm.setFieldsValue({ destinations: destinations })
        }
    }
    return (
        <Form.List key="destinations" name={["destinations"]}>
            {(fields, { add, remove }) => (
                <div>
                    <Row gutter={[16, 16]}>
                        {fields.map((field, i) => (
                            <PerDiemDestinationField
                                key={`per-diem-destination-field-${i}`}
                                elementField={field}
                                index={i}
                                remove={remove}
                                tripDestinations={currentDestinationsState}
                                adjustDestinationsOnChange={adjustDestinationsOnChange}
                            />
                        ))}
                        <Col span={24}>
                            <Button
                                onClick={() => {
                                    add()
                                    syncDestinationState()
                                }}
                            >
                                <PlusCircle />
                                {t("input:request.per_diem.add_destination")}
                            </Button>
                        </Col>
                    </Row>
                </div>
            )}
        </Form.List>
    )
}
